import React from 'react';
//eslint-disable-next-line import/no-unresolved
import logo from '~/components/Layout/images/logo-white.png?width=100';
/*
 * Customization with image
 *
 * If you have a jpg/png, do like this:
 *
 * <figure className="icon">
 *  <img src={logo} alt="" />
 * </figure>
 *
 * Note the icon class.
 */

const LogoFooter = () => (
  <img
    src={logo}
    width="100"
    height="62"
    alt="Biblioteche Pianura Est Logo"
    className="icon"
  />
);

export default LogoFooter;
